export default {
	PLEASE_UPLOAD: 'Please upload salary in CSV format',
	IDEAL_SALARY: 'Upload ideal salary % csv',
	MODAL_CONFIRM: 'Close',
};